import { InitiativeLevelType, InitiativePriority } from 'api/initiatives/types';

export interface CreateInitiativeFormState {
    name: string;
    category: string;
    type: string;
    level: InitiativeLevelType;
    levelEntity: string;
    kpi: string;
    startDate: string;
    endDate: string;
    ownerIds: string[];
    priority: InitiativePriority;
    capex: string;
    annualGrossSavings: string;
    annualTco2eAvoided: string;
}

export const DEFAULT_FORM_STATE: CreateInitiativeFormState = {
    name: '',
    category: '',
    type: '',
    level: 'SITE',
    levelEntity: '',
    kpi: '',
    startDate: '',
    endDate: '',
    ownerIds: [],
    priority: 'MEDIUM',
    capex: '',
    annualGrossSavings: '',
    annualTco2eAvoided: '',
};

export interface CreateInitiativeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}
